export const SidePanelType = Object.freeze({
    ButtonOptionsForm: 'buttonOptionsForm',
    DetailedData: 'detailedData',
});
